import { useAuth0 } from '@auth0/auth0-react';
import { makeStyles } from "@material-ui/core/styles";
import Card from "@mui/material/Card";
import CommunicationService from 'Lib/API/Communication';
import { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import CampaignDetails from './CampaignDetails/CampaignDetails';
import { CampaignTable } from './CampaignTable';
import { Wrapper } from './Theme';

export const Campaigns = ({setToggle,campaignIdParam,resetSearchParams}) => {
    const { getAccessTokenSilently } = useAuth0();
    const [page, setPage] = useState(0);
    const [campaignList,setCampaignList] = useState([])
    const [loading,setLoading] = useState(false)
    const [searchValue, setSearchValue] = React.useState("");
    const [count, setCount] = useState();
    const [refresh, setRefresh] = useState(false);
    const createCampainOpenDialog = useSelector((state) => state.communication.createCampainOpenDialog);
    const dialogWasOpen = useRef(false);
    const [sortBy, setSortBy] = useState("all");
    const [campainDetailsId,setCampainDetailsId] = useState('')
    const [sorting, setSorting] = useState({
        sort: {},
        search: undefined,
      });

    const useStyles = makeStyles({
      card: {
        borderRadius: "0",
        boxShadow: "none !important",
        height:'100%',
        "&:hover": {
          boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
        },
        marginTop:20,
        marginRight:20
      },

    });
    const classes = useStyles();
    

    
    const getCampaignList = async (initPage)=>{
      const currentPage = initPage || page;
        setLoading(true)
        const filterData = {
          ...sorting,
          filter: {
            status: sortBy,
            ...(campaignIdParam ? {
              campaignId: campaignIdParam
            } : {}),
          },
        }
        try{
            const token = await getAccessTokenSilently();
            const result = await CommunicationService.getCampaignList(token , currentPage + 1,30,filterData)
            setCount(result?.payload?.pagination?.count);
            setCampaignList(result?.payload?.data)
        }catch(err){
            toastr.error("Error", err?.data?.message);
        }finally{
            setLoading(false)
        }
    }
    useEffect(() => {
        if (dialogWasOpen.current && !createCampainOpenDialog) {
          setRefresh((prev) => !prev);
        }
        dialogWasOpen.current = createCampainOpenDialog;
      }, [createCampainOpenDialog]);
    useEffect(() => {
        if (searchValue === "") {
          setSorting({ ...sorting, search: undefined });
        } else {
          setSorting({ ...sorting, search: searchValue });
        }
      }, [searchValue]);
      
      const handleInputChange = (e) => {
        setPage(0);
        const inputValue = e.target.value;
        const regex = /[\\*\(\)\+]/;
        if (!regex.test(inputValue)) {
          setSearchValue(inputValue);
        }
      };


      const debounceSearch = useCallback(
        debounce(() => {
          if (sorting?.search) {
            getCampaignList();
          }
        }, 1000),
        [sorting?.search, sortBy, page, refresh]
      );
    
      useEffect(() => {
        if(campaignIdParam) return;
        if (sorting?.search) {
          debounceSearch();
        } else {
          getCampaignList();
        }
        return () => debounceSearch.cancel();
      }, [sorting,page,refresh,sortBy,campaignIdParam]);

      useEffect(() => {
        if(!campaignIdParam) return;
        setPage(0);
        getCampaignList(0);
      }, [campaignIdParam]);


    const onSortChange = (value) => {
      setPage(0);
      setSortBy(value);
    }

    
      const handleSort = (name) => {
        setSorting((prev) => ({
          ...prev,
          sort: {
            [name]: prev.sort[name] === 1 ? -1 : 1,
          },
        }));
      };
    return (
      <Card className={classes.card}>
          {campainDetailsId ? 
          <CampaignDetails campainDetailsId={campainDetailsId} 
           setCampainDetailsId={setCampainDetailsId}  setSortBy={setSortBy}/>
           :
           <CampaignTable
           setToggle={setToggle}
           campaignList={campaignList} page={page} loading={loading} 
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleInputChange={handleInputChange}
            setPage={setPage}
            setCount={setCount}
            count={count}
            handleSort={handleSort}
            refresh={refresh}
            setRefresh={setRefresh}
            onSortChange={onSortChange}
            setCampainDetailsId={setCampainDetailsId}
            resetSearchParams={resetSearchParams}
            campaignIdParam={campaignIdParam}
            />}
            
        </Card>
    );
};

